import Axios from 'axios'
import { API_URL } from '../config'
import { storage } from '../helpers'

const authRequestInterceptor = (config) => {
  const token = storage.getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  config.headers.Accept = 'application/json'
  return config
}

export const axios = Axios.create({
  baseURL: API_URL
})

axios.interceptors.request.use(authRequestInterceptor)
axios.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    console.error('Error axios: ', error?.toJSON() ?? error)
    return Promise.reject(error)
  }
)
